import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }

import { computed } from 'vue'

import SelectInput from '@/components/neue/SelectInput.vue'
import { TAX_STRUCTURE_OPTIONS, taxStructureName } from '@/helpers/taxStructure'
import api from '@/store/api'
import { mapRelationship } from '@/store/mappers'


export default {
  __name: 'ProfileTax',
  props: {
  conversationUserPairId: { type: [String, Number], required: true },
  editable: { type: Boolean, default: false }
},
  setup(__props) {

const props = __props

const pair = computed(() =>
  mapRelationship({ type: 'conversation_user_pair', id: String(props.conversationUserPairId) })
)

const taxStructure = computed(() => pair.value?.attributes?.tax_structure ?? null)

const saveTaxStructure = value => {
  api.call('PUT', `conversation_user_pairs/${props.conversationUserPairId}`, { tax_structure: value })
}

return (_ctx, _cache) => {
  return (__props.editable)
    ? (_openBlock(), _createBlock(SelectInput, {
        key: 0,
        class: "w-full",
        options: _unref(TAX_STRUCTURE_OPTIONS),
        "model-value": taxStructure.value,
        "onUpdate:modelValue": saveTaxStructure
      }, null, 8, ["options", "model-value"]))
    : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref(taxStructureName)(taxStructure.value)), 1))
}
}

}